  import {
    Card,
    Spin,
    Row,
    Col,
    Tag,
    Divider,
    Input,
    Icon,
    Form,
    Select,
    AutoComplete,
    DatePicker,
    List,
    Modal,
    Button,
  } from "antd";
  import React, { Component } from "react";
  import { withRouter } from "react-router-dom";
  import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
  import { Constants } from "../../data/constants";
  import Page from "../general/Page";
  import { Typography } from "antd";
  import TextArea from "antd/lib/input/TextArea";
  import { convertTZToLocalFormat } from "../general/DateTzHelper";
  import "./viewTicketDetails.css";
  import Comments from "./comments";
  import { TicketService } from "../../services/Ticket/TicketService";
  import { handleError } from "../../utils/ErrorHandlers";
  import moment from "moment";
  import { UserService } from "../../services/user/UserService";
  import { LoadingOutlined } from "@ant-design/icons";
  import { Translation } from "react-i18next";
  import ar from "antd/es/date-picker/locale/ar_EG";
  import en from "antd/es/date-picker/locale/en_US";
  import dayjs from "dayjs";
  import customParseFormat from "dayjs/plugin/customParseFormat";
  dayjs.extend(customParseFormat);

  const { Text } = Typography;
  const { Option } = Select;
  class ViewTicketDetails extends Component {
    constructor(props) {
      super(props);

      this.props.context.setCurrentComponent("viewTicketDetails");
      this.constants = new Constants();
      this.ticket = new TicketService();
      this.userService = new UserService();
      this.state = {
        ticket: {},
        isFetching: false,
        formLayout: "inline",
        commentLoading: false,
        loading: false,
        timeLineLoading: false,
        statusLoading: false,
        priorityLoading: false,
        dueDateLoading: false,
        userType: this.props.context.user.userType,
        comment: "",
        editSubject: false,
        willComment: false,
        openConfirmModal: false,
        selectedPriority: "",
        selectedStatus: "",
        selectedAssignee: "",
        selectedDuedate: "",
        actionSelected: "",
        actionValue: "",
        commentFieldStatus:"success",
        // btnLabel: "Close issue",
        // status: "Open",
        // priority: "High",
        // assignTo: "Menna",
        // dueDate: "2022-02-21 12:30:00",
        // ticketSubject: "check internet conncectivity",
        //prevStatus: "",
        currentAssignedUser: "",
        currentStatus: "",
        isClosed: false,
        reOpened: false,
        comments: [],
        allUsers: [],
        adminUsers: [],
        ticketTracking: [],
        trackingList: {
          changeType: "",
          ticketId: "",
          commentId: "",
          trackingObject: {
            action: "",
            userName: "",
            prevState: "",
            currState: "",
            createdOn: "",
          },
        },
        lang:
          this.props.context.curr_lang === "ar" &&
          this.props.context.curr_dir === "rtl"
            ? "ar"
            : "en",
      };
    }
    disabledDate = (current) => {
      // Can not select days after today
      return current < dayjs().startOf("day");
    };

    async componentDidMount() {
      try {
        this.setState({ isFetching: true });
        await this.getTicketData();
        let [comments, ticketTracking] = await Promise.all([
          this.getComments(),
          this.getTracking(),
        ]);

        let commentsTrackingMap = this.mapTimelineToComment(
          comments,
          ticketTracking
        );

        let users = [];
        let adminUsers = [];
        if (this.state.userType === "ADMIN") {
          users = await this.getAllUsers();
        } else {
          adminUsers = await this.filterUsersByType();

          adminUsers.ivrList.push({
            userId: this.props.context.user.userId,
            userFullname: this.props.context.user.userFullname,
          });
        }

        this.setState({
          allUsers: users.ivrList,
          adminUsers: adminUsers.ivrList,
          comments: commentsTrackingMap,
          isFetching: false,
        });
      } catch (e) {
        this.setState({
          isFetching: false,
        });
        handleError(e);
      }
    }

    async getAllUsers() {
      try {
        let data = await this.userService.getAllUsersByAccountIdService(
          this.props.context.session_id
        );
        return data;
      } catch (e) {
        handleError(e);
      }
    }
    async filterUsersByType() {
      try {
        let data = await this.userService.getUserByTypeService(
          this.props.context.session_id,
          "ADMIN"
        );
        return data;
      } catch (e) {
        handleError(e);
      }
    }

    getUsersName(id) {
      let { allUsers, adminUsers, userType } = this.state;

      if (userType === "ADMIN") {
        return allUsers.find((user) => user.userId === id).userFullname;
      } else {
        return adminUsers.find((user) => user.userId === id).userFullname;
      }
    }

    async getTracking() {
      try {
        let ticketTrackingData = await this.ticket.getCommentsTimeLine(
          this.props.context.session_id,
          this.state.ticket.id
        );

        return ticketTrackingData.ivrList;
      } catch (e) {
        handleError(e);
      }
    }

    async getComments() {
      try {
        let allComments = await this.ticket.getAllCommentsService(
          this.props.context.session_id,
          this.state.ticket.number
        );

        return allComments.ivrList;
      } catch (e) {
        handleError(e);
      }
    }
    async getTicketData() {
      let { id } = this.props.match.params;
      try {
        this.ticket = new TicketService();
        let ticketData = await this.ticket.getTicketById(
          this.props.context.session_id,
          id
        );

        this.setState({
          ticket: ticketData.ivrCustomEntityObject,
          currentAssignedUser: ticketData.ivrCustomEntityObject.assignedTo,
          currentStatus: ticketData.ivrCustomEntityObject.status,
          // isClosed:
          //   ticketData.ivrCustomEntityObject.status === "Closed" ? true : false,
        });
      } catch (e) {
        handleError(e);
      }
    }

    setTrackingListValues(
      changeType,
      ticketId,
      commentId,
      action,
      userName,
      prevState,
      currState,
      createdOn
    ) {
      let { trackingList } = this.state;
      trackingList.commentId = commentId;
      trackingList.ticketId = ticketId;
      trackingList.changeType = changeType;
      trackingList.createdOn = createdOn;
      trackingList.trackingObject.prevState = prevState;
      trackingList.trackingObject.userName = userName;
      trackingList.trackingObject.currState = currState;
      trackingList.trackingObject.action = action;

      this.setState({ trackingList: trackingList });
    }

    getTextAreaInput = (e) => {
      this.setState({
        comment: e.target.value,
        willComment: e.target.value ? true : false,
      });
      e.target.value = "";
    };

    onStatusChange = (value) => {
      if (value !== this.state.ticket.status) {
        this.setState({
          currentStatus: value,
        });
      }
    };

    onStatusSelect = async (value) => {
      let { ticket, comments, trackingList } = this.state;
      let action = "changed status from";
      let values = [{}];
      let valueState = "status";

      if (value === "Closed") {
        valueState = "close";
        action = "closed issue";
      } else if (value === "Open") {
        valueState = "reOpen";
        action = "re-opend issue";
      }
      values["status"] = value;
      values["ticketId"] = this.state.ticket.id;

      try {
        if (value !== this.state.ticket.status) {
          this.setState({ commentLoading: true });
          let data = await this.ticket.editStatus(
            this.props.context.session_id,
            values
          );

          this.setTrackingListValues(
            valueState,
            this.state.ticket.id,
            this.state.comments.at(-1).id,
            action,
            this.props.context.user.userFullname,
            this.state.ticket.status,
            value,
            moment().format("YYYY-MM-DD HH:mm:ss")
          );

          let trackedData = await this.ticket.insertTimeline(
            this.props.context.session_id,
            trackingList
          );

          if (
            data.statusMsg === "success" &&
            trackedData.statusMsg === "success"
          ) {
            ticket.status = value;
            comments.at(-1).trackingList.push({
              changeType: trackingList.changeType,
              ticketId: trackingList.ticketId,
              commentId: trackingList.commentId,
              createdOn: trackingList.createdOn,
              trackingObject: {
                action: trackingList.trackingObject.action,
                userName: trackingList.trackingObject.userName,
                prevState: trackingList.trackingObject.prevState,
                currState: trackingList.trackingObject.currState,
              },
            });

            this.setState({
              ticket,
              comments,
              commentLoading: false,
            });
            document.getElementById("commentInput").value = "";
          }
        }
      } catch (e) {
        this.setState({ commentLoading: false });
        handleError(e);
      }
    };

    onPrioritySelect = async (value) => {
      let { ticket, trackingList, comments } = this.state;
      let values = [{}];
      values["priority"] = value;
      values["ticketId"] = this.state.ticket.id;
      this.setTrackingListValues(
        "priority",
        this.state.ticket.id,
        this.state.comments.at(-1).id,
        "changed priority from ",
        this.props.context.user.userFullname,
        this.state.ticket.priority,
        value,
        moment().format("YYYY-MM-DD HH:mm:ss")
      );
      try {
        if (value !== this.state.ticket.priority) {
          this.setState({ timeLineLoading: true });
          let data = await this.ticket.editPriority(
            this.props.context.session_id,
            values
          );

          let trackedData = await this.ticket.insertTimeline(
            this.props.context.session_id,
            trackingList
          );

          if (
            data.statusMsg === "success" &&
            trackedData.statusMsg === "success"
          ) {
            ticket.priority = value;

            comments.at(-1).trackingList.push({
              changeType: trackingList.changeType,
              ticketId: trackingList.ticketId,
              commentId: trackingList.commentId,
              createdOn: trackingList.createdOn,
              trackingObject: {
                action: trackingList.trackingObject.action,
                userName: trackingList.trackingObject.userName,
                prevState: trackingList.trackingObject.prevState,
                currState: trackingList.trackingObject.currState,
              },
            });
          }
          this.setState({
            ticket,
            comments,
            timeLineLoading: false,
          });
        }
      } catch (e) {
        this.setState({ timeLineLoading: false });
        handleError(e);
      }
    };
    onAssignSelect = async (value) => {
      let { ticket, trackingList, comments } = this.state;
      let values = [{}];
      values["assignedTo"] = value;
      values["ticketId"] = this.state.ticket.id;
      this.setTrackingListValues(
        "assign",
        this.state.ticket.id,
        this.state.comments.at(-1).id,
        "assigned issue ",
        this.props.context.user.userFullname,
        "",
        this.getUsersName(value),
        moment().format("YYYY-MM-DD HH:mm:ss")
      );

      try {
        if (this.getUsersName(value) !== this.state.ticket.assignedTo) {
          this.setState({ timeLineLoading: true });
          let data = await this.ticket.editAssignedTo(
            this.props.context.session_id,
            values
          );

          let trackedData = await this.ticket.insertTimeline(
            this.props.context.session_id,
            trackingList
          );

          if (
            data.statusMsg === "success" &&
            trackedData.statusMsg === "success"
          ) {
            ticket.assignedTo = this.getUsersName(value);
            comments.at(-1).trackingList.push({
              changeType: trackingList.changeType,
              ticketId: trackingList.ticketId,
              commentId: trackingList.commentId,
              createdOn: trackingList.createdOn,
              trackingObject: {
                action: trackingList.trackingObject.action,
                userName: trackingList.trackingObject.userName,
                prevState: trackingList.trackingObject.prevState,
                currState: trackingList.trackingObject.currState,
              },
            });
          }
          this.setState({
            ticket,
            comments,
            timeLineLoading: false,
          });
        }
      } catch (e) {
        this.setState({ timeLineLoading: false });
        handleError(e);
      }
    };

    onDateChange = async (dateString) => {
      let { ticket, trackingList, comments } = this.state;
      let values = [{}];
      values["dueDate"] = dateString;
      values["ticketId"] = this.state.ticket.id;
      this.setTrackingListValues(
        "dueDate",
        this.state.ticket.id,
        this.state.comments.at(-1).id,
        "changed due date from",
        this.props.context.user.userFullname,
        this.state.ticket.dueDate,
        dateString,
        moment().format("YYYY-MM-DD HH:mm:ss")
      );
      try {
        if (dateString !== this.state.ticket.dueDate) {
          this.setState({ timeLineLoading: true });
          let data = await this.ticket.editDueDate(
            this.props.context.session_id,
            values
          );

          let trackedData = await this.ticket.insertTimeline(
            this.props.context.session_id,
            trackingList
          );

          if (
            data.statusMsg === "success" &&
            trackedData.statusMsg === "success"
          ) {
            ticket.dueDate = dateString;
            comments.at(-1).trackingList.push({
              changeType: trackingList.changeType,
              ticketId: trackingList.ticketId,
              commentId: trackingList.commentId,
              createdOn: trackingList.createdOn,
              trackingObject: {
                action: trackingList.trackingObject.action,
                userName: trackingList.trackingObject.userName,
                prevState: trackingList.trackingObject.prevState,
                currState: trackingList.trackingObject.currState,
              },
            });
          }
          this.setState({
            ticket,
            comments,
            timeLineLoading: false,
          });
        }
      } catch (e) {
        this.setState({ timeLineLoading: false });
        handleError(e);
      }
    };

    componentDidUpdate(prevProps) {
      if (prevProps.location.key !== this.props.location.key) {
        this.componentDidMount();
      }
    }

    handleComment = async (e) => {

      e.preventDefault();
      // this.props.form.validateFields((err, values) => {
      //   if (!err) {
      //     console.log('Received values of form: ', values);
      //     this.setState({commentFieldStatus:"error"});
      //     console.log(this.state.comment);
      //   }
      // });
      if(this.state.comment.trim()==""){
        this.setState({commentFieldStatus:"error"});
        return;
      }
  let newComment = {
        content: this.state.comment,
        ticketNumber: this.state.ticket.number,
        createdBy: this.props.context.user.userFullname,
        createdOn: moment().format("yyyy-mm-dd"),
        trackingList: [],
      };
      let { comments } = this.state;
      this.setState({
        commentLoading: true,
      });
      try {
        let data = await this.ticket.createComment(
          this.props.context.session_id,
          newComment
        );

        comments = await this.getComments();
        let track = await this.getTracking();

        this.mapTimelineToComment(comments, track);

        this.setState({
          comments,
        });

        if (
          this.state.currentStatus !== this.state.ticket.status &&
          this.state.currentStatus !== ""
        ) {
          this.onStatusSelect(this.state.currentStatus);
        } else {
          this.setState({
            commentLoading: false,
          });
        }
        document.getElementById("commentInput").value = "";
        this.setState({comment:""})

      } catch (e) {
        this.setState({
          commentLoading: false,
        });
        handleError(e);
      }
    };

    // handleClose = async () => {
    //   try {
    //     this.setState({ loading: true });

    //     let isClosed = !this.state.isClosed;

    //     this.setState({
    //       isClosed: isClosed,
    //       btnLabel: isClosed ? "Reopen issue " : "Close issue",
    //       status: isClosed ? "Closed" : "Open",
    //       //reOpened: !isClosed,
    //     });
    //     let values = [{}];
    //     values["status"] = isClosed ? "Closed" : "Open";
    //     values["ticketId"] = this.state.ticket.id;

    //     let { ticket, trackingList, comments } = this.state;
    //     let changeType = isClosed ? "close" : "reOpen";
    //     let action = isClosed ? " closed issue " : "re-opend issue";
    //     this.setTrackingListValues(
    //       changeType,
    //       this.state.ticket.id,
    //       this.state.comments.at(-1).id,
    //       action,
    //       this.props.context.user.userFullname,
    //       this.state.ticket.status,
    //       this.state.status,
    //       moment().format("YYYY-MM-DD HH:mm:ss")
    //     );

    //     let data = await this.ticket.editStatus(
    //       this.props.context.session_id,
    //       values
    //     );

    //     let trackedData = await this.ticket.insertTimeline(
    //       this.props.context.session_id,
    //       trackingList
    //     );
    //     if (trackedData.statusMsg === "success" && data.statusMsg === "success") {
    //       ticket.status = this.state.status === "Closed" ? "Closed" : "Open";
    //       comments.at(-1).trackingList.push({
    //         changeType: trackingList.changeType,
    //         ticketId: trackingList.ticketId,
    //         commentId: trackingList.commentId,
    //         createdOn: trackingList.createdOn,
    //         trackingObject: {
    //           action: trackingList.trackingObject.action,
    //           userName: trackingList.trackingObject.userName,
    //           prevState: trackingList.trackingObject.prevState,
    //           currState: trackingList.trackingObject.currState,
    //         },
    //       });
    //     }
    //     this.setState({
    //       ticket,
    //       comments,
    //       loading: false,
    //     });
    //   } catch (e) {
    //     this.setState({
    //       loading: false,
    //     });
    //     handleError(e);
    //   }
    // };

    handlePriorityChange = (value) => {
      if (value !== this.state.ticket.priority) {
        this.setState({
          selectedPriority: value,
          actionSelected: " priority",
          openConfirmModal: true,
          actionValue: value,
        });
      }
    };
    handleStatusChange = (value) => {
      if (value !== this.state.ticket.status) {
        this.setState({
          selectedStatus: value,
          actionSelected: " status",
          openConfirmModal: true,
          actionValue: value,
        });
      }
    };
    handleDueDateChange = (data, dateString) => {
    
      if(dateString==""){
        handleError({message:"Due date is required"});
        return;
      }
      if (dateString !== this.state.ticket.dueDate) {
        this.setState({
          selectedDuedate: dateString,
          actionSelected: " due date",
          openConfirmModal: true,
          actionValue: dateString,
        });
      }
    };
    handleAssigneeChange = (value) => {
      if (this.getUsersName(value) !== this.state.ticket.assignedTo) {
        this.setState({
          selectedAssignee: value,
          actionSelected: " assigned user",
          openConfirmModal: true,
          actionValue: this.getUsersName(value),
        });
      }
    };

    mapTimelineToComment(commentList, trackingList) {
      let comments = commentList;
      commentList.forEach((element, index) => {
        let dummytrackingList = trackingList.filter(
          (value) => element.id === value.commentId
        );
        comments[index].trackingList = dummytrackingList;
      });

      return comments;
    }

    handleOk = () => {
      // let { ticket } = this.state;
      switch (this.state.actionSelected) {
        case " priority":
          this.onPrioritySelect(this.state.selectedPriority);

          break;
        case " due date":
          this.onDateChange(this.state.selectedDuedate);

          break;
        case " assigned user":
          this.onAssignSelect(this.state.selectedAssignee);
          this.setState({ currentAssignedUser: this.state.selectedAssignee });
          break;
        default:
          //ticket.status = this.state.selectedStatus;
          //this.setState({ currentStatus: this.state.selectedStatus });
          break;
      }
      this.setState({ openConfirmModal: false });
    };

    handleCancel = () => {
      // let { ticket, currentAssignedUser } = this.state;
      // if (currentAssignedUser === ticket.assignedTo) {

      //   currentAssignedUser = ticket.assignedTo;
      //   this.setState({
      //     currentAssignedUser,
      //     openConfirmModal: false,
      //   });
      //   document.getElementById("assignInput").value = currentAssignedUser;
      // } else {
      this.setState({
        openConfirmModal: false,
      });
      //}
    };

    render() {
      let { isFetching, ticket, comments, allUsers, userType, adminUsers } =
        this.state;
      const UsersOptions = allUsers
        ? allUsers.map((opt) => (
            <Option key={opt.userFullname} value={opt.userId}>
              {opt.userFullname}
            </Option>
          ))
        : "";

      const agentUserOptions = adminUsers
        ? adminUsers.map((opt) => (
            <Option key={opt.userFullname} value={opt.userId}>
              {opt.userFullname}
            </Option>
          ))
        : "";

      return (
        <Translation>
          {(t) => (
            <Page title={t("Ticket Details")} hasBackArrow={true}>
              {isFetching ? (
                <Spin></Spin>
              ) : (
                <Spin
                  spinning={this.state.timeLineLoading}
                  indicator={<LoadingOutlined spin />}
                  size="large"
                >
                  <div style={{ opacity: "20" }}>
                    <Typography.Title
                      level={4}
                      style={{
                        margin: 0,
                      }}
                    >
                      {ticket.subject}{" "}
                      <Text type="secondary">#{ticket.number}</Text>
                    </Typography.Title>
                    <Row>
                      <Col span={19}>
                        <Card
                          style={{
                            marginTop: "10px",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                            padding: "20px",
                          }}
                          bordered={false}
                        >
                          <Row>
                            <Col xs={24} lg={8}>
                              <Text className="small-text"> {t("Status")}</Text>
                              <Tag className="m-2">{t(ticket.status)}</Tag>
                            </Col>
                            <Col xs={24} lg={8}>
                              <Text className="small-text"> {t("User")} </Text>
                              <Tag className="m-2">{ticket.assignedTo}</Tag>
                            </Col>
                            <Col xs={24} lg={8}>
                              <Text className="small-text">
                                {" "}
                                {t("Create Date")}
                              </Text>
                              <Tag className="m-2">
                                {convertTZToLocalFormat(ticket.createdOn)}
                              </Tag>
                            </Col>

                            <Col xs={24} lg={8}>
                              <Text className="small-text">
                                {" "}
                                {t("Priority")}
                              </Text>
                              <Tag className="m-2">{t(ticket.priority)}</Tag>
                            </Col>

                            <Col xs={24} lg={8}>
                              <Text className="small-text">
                                {" "}
                                {t("Customer")}
                              </Text>
                              <Tag className="m-2">{ticket.customerId} </Tag>
                            </Col>
                            <Col xs={24} lg={8}>
                              <Text className="small-text">
                                {" "}
                                {t("Due Date")}
                              </Text>
                              <Tag className="m-2">{convertTZToLocalFormat(ticket.dueDate)}</Tag>
                            </Col>
                          </Row>
                        </Card>

                        {comments ? (
                          <List
                            dataSource={comments}
                            renderItem={(item) => {
                              return (
                                <div>
                                  <Comments commentList={item}></Comments>
                                </div>
                              );
                            }}
                          />
                        ) : (
                          <Comments commentList={comments}></Comments>
                        )}

                        <div style={{ marginTop: "10px" }}>
                          <Form.Item
                            validateStatus={this.state.commentFieldStatus}
                            help={
                              this.state.commentFieldStatus == "error"
                                ? t(
                                    "Please enter your comment to change the status"
                                  )
                                : ""
                            }
                          >
                            <TextArea
                              rows={4}
                              maxLength={250}
                              onChange={(value) => {
                                this.setState({
                                  commentFieldStatus: "success",
                                });
                                this.getTextAreaInput(value);
                              }}
                              placeholder={t("Please Enter Your Comment")}
                              id="commentInput"
                              value={this.state.comment}
                            ></TextArea>
                          </Form.Item>
                          {/* <Form.Item label="Status" {...formItemLayout}> */}
                          <Row style={{ marginTop: "10px" }}>
                            <Col xs={24} lg={8}>
                              <Text className="small-text">
                                {" "}
                                {t("Ticket Status:")}
                              </Text>
                              {/* <Tag className="m-2">{ticket.status}</Tag> */}

                              <Select
                                defaultValue={this.state.currentStatus}
                                style={{ width: "50%" }}
                                onSelect={this.onStatusChange}
                              >
                                <Option value={"Open"}>{t("Open")}</Option>
                                <Option value={"Resolved"}>
                                  {t("Resolved")}
                                </Option>
                                <Option value={"Invalid"}>
                                  {t("Invalid")}
                                </Option>
                                <Option value={"Closed"}>{t("Closed")}</Option>
                              </Select>
                            </Col>
                            {/* </Form.Item> */}
                          </Row>
                          <Form.Item
                            wrapperCol={{
                              xs: { span: 24, offset: 0 },
                              sm: { span: 16, offset: 8 },
                            }}
                          >
                            <Button
                              className="button-submit"
                              type="primary"
                              onClick={this.handleComment}
                              size={"small"}
                              loading={this.state.commentLoading}
                            >
                              {t("Submit")}
                            </Button>
                            {/* <Button
                          className="button-submit"
                          type="primary"
                          onClick={this.handleClose}
                          size={"small"}
                          loading={this.state.loading}
                        >
                          {ticket.status === "Closed"
                            ? "Reopen issue"
                            : this.state.btnLabel}
                
                        </Button> */}
                          </Form.Item>
                        </div>
                      </Col>
                      <Col span={1} style={{ height: "700px" }}>
                        <Divider
                          type="vertical"
                          style={{ height: "100%", width: "3px" }}
                        />
                      </Col>
                      <Col
                        span={4}
                        style={{ paddingLeft: "5px", marginTop: "30px" }}
                      >
                        {/* {userType === "ADMIN" ? ( */}
                        <Form.Item label={t("Assign To")}>
                          <AutoComplete
                            id="assignInput"
                            className="certain-category-search"
                            dropdownClassName="certain-category-search-dropdown"
                            dropdownMatchSelectWidth={false}
                            defaultValue={ticket.assignedTo}
                            // dropdownStyle={{ width: "100%" }}
                            size="large"
                            style={{ width: "100%" }}
                            placeholder={t("Select User to assign  ")}
                            dataSource={
                              userType === "ADMIN"
                                ? UsersOptions
                                : agentUserOptions
                            }
                            onSelect={(value) =>
                              this.handleAssigneeChange(value)
                            }
                            filterOption={(inputValue, option) =>
                              option.props.children
                                .toUpperCase()
                                .indexOf(inputValue.toUpperCase()) !== -1
                            }
                          >
                            <Input
                              // id="assignInput"
                              suffix={
                                <Icon
                                  type="search"
                                  className="certain-category-icon"
                                />
                              }
                            />
                          </AutoComplete>
                        </Form.Item>
                        <Form.Item label={t("Priority")}>
                          <Select
                            placeholder={t("Select ")}
                            style={{ width: "100%" }}
                            value={ticket.priority}
                            onSelect={this.handlePriorityChange}
                          >
                            <Option value={"Critical"}>{t("Critical")}</Option>
                            <Option value={"High"}>{t("High")}</Option>
                            <Option value={"Normal"}>{t("Normal")}</Option>
                            <Option value={"Low"}>{t("Low")}</Option>
                          </Select>
                        </Form.Item>
                        {/* <Form.Item label="Status">
                      <Select
                        value={ticket.status}
                        style={{ width: "100%" }}
                        onSelect={this.onStatusSelect}
                      >
                        <Option value={"Open"} style={{ display: "none" }}>
                          Open
                        </Option>
                        <Option value={"Resolved"}>Resolved</Option>
                        <Option value={"Invalid"}>Invalid</Option>
                        <Option value={"Closed"} style={{ display: "none" }}>
                          Closed
                        </Option>
                      </Select>
                    </Form.Item> */}

                        <Form.Item label={t("Due Date")}>
                          <DatePicker
                            disabledDate={this.disabledDate}
                            value={moment(ticket.dueDate)}
                            onSelect
                            onChange={this.handleDueDateChange}
                            locale={this.state.lang === "ar" ? ar : en}
                            format={"yyyy-MM-DD"}
                            allowClear={false}
                            
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Modal
                      title={t("Confirm")}
                      visible={this.state.openConfirmModal}
                      onOk={this.handleOk}
                      onCancel={this.handleCancel}
                      okText={t("OK")}
                      cancelText={t("Cancel")}
                    >
                      {t("Are you sure you want to change")}{" "}
                      {t(this.state.actionSelected)} {t("to")}{" "}
                      <Text strong> {t(this.state.actionValue)}</Text> {t("?")}
                    </Modal>
                  </div>
                </Spin>
              )}
            </Page>
          )}
        </Translation>
      );
    }
  }

  export default withSharedStateConsumer(withRouter(ViewTicketDetails));
